module.exports = __webpack_public_path__ + "img/9.13f18eb8.jpg";